const SummaryTableSchema = [
    {
        objectName: 'selectedDashboardSummary',
        isLoading: 'loadingSelectedDashboardSummary',
        children: [
            {
                label: 'Last Modified',
                fieldNames: ['LastModifiedDate'],
            },
            {
                label: 'Created',
                fieldNames: ['CreatedDate']
            },
            {
                label: 'Status',
                fieldNames: ['DashStatus']
            },
        ]
    },
];

export default SummaryTableSchema;
